import { useEffect, useState } from "react";
import MyRangeDatePicker from "../../components/DatePickerRange";
import api from "../../../../api";
export const ScheduleBlockForm = ({
    dialogRef,
    idSchedule,
    initialBlockDate,
    onSave,
    notify,
}) => {
    const today = new Date();
    const formatLocalDate = (date) => {
        return [
            date.getFullYear(),
            String(date.getMonth() + 1).padStart(2, "0"),
            String(date.getDate()).padStart(2, "0"),
        ].join("-");
    };
    const [blockDate, setBlockDate] = useState({
        schedule: idSchedule,
        startDate: formatLocalDate(today),
        endDate: "",
        reason: "",
    });

    useEffect(() => {
        if (initialBlockDate) {
            setBlockDate({
                schedule: idSchedule,
                id: initialBlockDate.id, // si viene con id
                startDate: initialBlockDate.startDate,
                endDate:
                initialBlockDate.endDate === initialBlockDate.startDate
                    ? ""
                    : initialBlockDate.endDate,
                reason: initialBlockDate.reason || "",
            });
        }
    }, [initialBlockDate, idSchedule]);

    const handleSubmit = async (event) => {
        event.preventDefault();
        const payload = {
            ...blockDate,
            endDate: blockDate.endDate || blockDate.startDate,
        };
        try {
            if (blockDate.id) {
                await api.schedulesBlock.update(blockDate.id, payload);
                notify("Actualizado correctamente", "success");
                onSave?.();
            } else {
                await api.schedulesBlock.create(payload);
                notify("Fecha bloqueada correctamente", "success");
                onSave?.();
            }
        } catch (error) {
            console.error("Error al bloquear la agenda:", error);
            if (error?.message && typeof error.message === "object") {
                const messages = Object.values(error.message).flat().join("\n");
                notify(messages, "error");
            } else {
                notify(
                    "Hubo un error al bloquear la agenda. Inténtalo nuevamente",
                    "error"
                );
            }
        }
    };

    const handleChange = (field, value) => {
        setBlockDate((prev) => ({
            ...prev,
            [field]: value,
        }));
    };

    return (
        <div className="flex flex-col h-full bg-white dark:bg-gray-900 text-black dark:text-white">
            <div className="text-white bg-[#8098F9] dark:bg-[#4f5ea5]  p-5">
                <h2 className="text-3xl font-bold">Bloqueo de fechas</h2>
                <small className="text-[#C7D7FE]">
                    Complete los datos para registrar el bloqueo.
                </small>
            </div>
            <form
                onSubmit={handleSubmit}
                className=" text-gray-800 dark:text-gray-200 flex flex-col justify-between h-full"
            >
                <div className="p-5 flex flex-col gap-5">
                    <div className="flex flex-col gap-2">
                        <label htmlFor="date" className="font-semibold">
                            Fecha
                        </label>
                        <div>
                            <MyRangeDatePicker
                                appointment={blockDate}
                                handleDateChange={handleChange}
                                disabled={false}
                            />
                        </div>
                    </div>
                    <div className="flex flex-col gap-2">
                        <label htmlFor="reason" className="font-semibold">
                            Rason
                        </label>
                        <textarea
                            name="reason"
                            id="reason"
                            rows={6}
                            className="border-gray-200 rounded-lg input-base"
                            onChange={(e) =>
                                handleChange("reason", e.target.value)
                            }
                            value={blockDate.reason}
                        ></textarea>
                    </div>
                </div>
                <div className="flex justify-end gap-3 p-5 border-t border-gray-200 dark:border-gray-700">
                    <button
                        type="button"
                        className="text-gray-500 dark:text-gray-200 "
                        onClick={() => {
                            dialogRef.current?.close();
                        }}
                    >
                        Cancelar
                    </button>
                    <button
                        type="submit"
                        className="bg-primary text-white px-4 py-2 rounded-lg disabled:cursor-not-allowed disabled:bg-gray-500 disabled:text-gray-200 "
                    >
                        Guardar
                    </button>
                </div>
            </form>
        </div>
    );
};
